import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";
import { useAuth } from "../../auth/AuthContext";
import { Flex, Spinner } from "@chakra-ui/react";
import { useCustomTheme } from "../../contexts/CustomThemeContext";

const LoginOrRedirect = () => {
    const authContext = useAuth() as any;
    const user = authContext?.user;
    const loading = authContext?.loading || authContext?.isLoading || false;

    const navigate = useNavigate();
    const { theme } = useCustomTheme();

    useEffect(() => {
        if (!loading && user) {
            navigate("/dashboard", { replace: true });
        }
    }, [user, loading, navigate]);

    if (loading) {
        return (
            <Flex
                bg={theme.background}
                color={theme.text}
                h="100%"
                align="center"
                justify="center"
            >
                <Spinner size="lg" />
            </Flex>
        );
    }

    if (!user) {
        return (
            <Flex bg={theme.background} color={theme.text} h="100%" pt="20px">
                <Login />
            </Flex>
        );
    }

    return null;
};

export default LoginOrRedirect;